type GetPaginationSummaryOptions = {
  page: number;
  pageCount: number;
  totalItems: number;
  pageSize?: number;
};

export type PaginationSummary = {
  from: number;
  to: number;
  total: number;
};

// Which rows the current page covers
export function getPaginationSummary({
  page,
  pageCount,
  totalItems,
  pageSize,
}: GetPaginationSummaryOptions): PaginationSummary | null {
  if (totalItems <= 0 || pageCount <= 0) {
    return null;
  }

  const size = pageSize ?? Math.ceil(totalItems / pageCount);

  if (size <= 0) {
    return null;
  }

  const current = Math.min(Math.max(page, 1), pageCount);
  const from = (current - 1) * size + 1;

  if (from > totalItems) {
    return null;
  }

  return { from, to: Math.min(current * size, totalItems), total: totalItems };
}
